import { render } from "./ManageDeliveries.vue?vue&type=template&id=0ba48bdc"
import script from "./ManageDeliveries.vue?vue&type=script&lang=js"
export * from "./ManageDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__